import { SelectDropdown } from '../shared/select-dropdown-v2';
import { getPageQueryParam } from '../utils/get-page-url';

export class DropdownVariantHandler {
  constructor(container, switcher, isActiveContainer) {
    this.container = container;
    this.isActiveContainer = isActiveContainer;
    this.select = new SelectDropdown(switcher, this.handleChange);
  }

  setVariantIdToContainer = (variantId) => {
    this.container.dataset.variantId = variantId;
  };

  handle = ({ currentVariant }) => {
    if (currentVariant == null) {
      return;
    }

    const { variantId } = currentVariant;

    this.changeSelectUI(variantId);
    this.runHandlers(variantId);
  };

  runHandlers = (variantId) => {
    const variantData = window.variantDataSelector.getData(variantId);

    this.handlers.forEach((handler) => handler.handle(variantData, this.container));
  };

  handleChange = ([variantId]) => {
    const variantData = window.variantDataSelector.getData(variantId);
    const isOtpDisabled = variantData.disablePurchaseType === 'otp';
    const subscriptionId = variantData?.subscriptionId
        || window.currentVariantStorage.state.currentVariant?.subscriptionId;

    this.setVariantIdToContainer(variantId);

    if (isOtpDisabled) {
      window.currentVariantStorage.setState({ currentVariant: variantData, subscription: 'subscription' });
    } else if (!subscriptionId) {
      window.currentVariantStorage.setState({ currentVariant: variantData, subscription: 'one-time' });
    } else {
      window.currentVariantStorage.setCurrentVariant(variantData);
    }
  };

  changeSelectUI = (variantId) => {
    const currentOption = this.select.getPurposeOption(variantId);

    this.select.change(currentOption);
  };

  initializeEventListeners = () => {
    const currentOption = this.select.getPurposeOption(getPageQueryParam('variant'));
    const currentVariant = window.variantDataSelector.getData(currentOption.value);

    this.select.init(currentOption);
    this.setVariantIdToContainer(currentOption.value);

    if (this.isActiveContainer) {
      window.currentVariantStorage.setState({ currentVariant, subscription: 'subscription' });
    }

    this.runHandlers(currentOption.value);

    window.currentVariantStorage.subscribe(this);
  };
}
